module.exports = __webpack_public_path__ + "img/229,626.cd8b045e.svg";